import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader, TrueFalseRadio } from "../../../NewBusinessWizard/Components/SharedComponents";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { PensionTypesArray, PensionTypesArrayNoITFLS, PensionTypesMap } from "../../../Common/Resource/Contents";
import { incomePaymentDetailsLabels } from "../../../Common/SIPP/IncomePaymentDetails/Resource/Content";
import { PensionType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { StaticUrls } from "../../../../../Resoures/StaticUrls";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { checkPermission } from "../../../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../../../Wrap/Constants/Enums/UserClaim";
import { DPCQuestion } from "../../../Common/Pension/DPCQuestion";
import { RetirementAge } from "../../../Common/PaymentsIn/SIPP/RetirementAge";
import { PensionProtection } from "../../../Common/PaymentsIn/SIPP/PensionProtection";
interface ISIPPSectionProps extends IProcessComponentProps {
    HasExistingSIPP?: boolean;
    subAccountId?: string;
    subAccountHierarchyId?: string;
    isAddRegularPayment?: boolean;
}

interface ISIPPSectionState { }

export class SIPPSection extends ProcessComponent<ISIPPSectionProps, ISIPPSectionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }
    componentDidMount() {
        super.componentDidMount();
        if (this.props.HasExistingSIPP == true) {
            this.props.data.Product.PensionType = PensionType.None;
        }
    }

    private onProductChange(changes, product, index) {
        const _product = JSON.parse(JSON.stringify(product));
        for (const key in changes) {
            _product[key] = changes[key];
        }
        const data = this.props.data.SelectedProducts.concat();
        data[index] = _product;
        this.props.onChange({ SelectedProducts: data });
    }

    private onDpcChange(change) {
        const v = change?.SelectedProducts?.find((e) => e.SubAccountType == SubAccountType.Npr)?.IsDisqualifyingPensionCredits
        if (!v) {
            this.props.onChange(change)
        }
        else {
            const selectedProducts = change.SelectedProducts.find((e) => e.SubAccountType == SubAccountType.Npr)
            if (selectedProducts.PensionType == PensionType.ImmediateTaxFreeLumpSum) (
                selectedProducts.PensionType = PensionType.None
            )
            
            selectedProducts.IsIncomePaymentDetailsSelected = false
            
            this.props.onChange({
                ...change,
                SelectedProducts: [selectedProducts]
            })
        }
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            isReview: isReview,
        };
    };

    public render(): JSX.Element {
        const { data } = this.props;
        const productIndex = data.SelectedProducts.findIndex((e) => e.SubAccountType == SubAccountType.Npr);
        const Product = data.SelectedProducts[productIndex];
        return (
            <>
                {SectionHeader("Pension options")}
                {this.props.HasExistingSIPP == true &&
                    checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite) && (
                        <Alert
                            alertType={AlertType.Warning}
                            message={
                                <span>
                                    As your client already has an existing SIPP, you will only be able to add transfers
                                    in for one or more post-retirement SIPP accounts. Please use the{" "}
                                    <a
                                        href={StaticUrls.SinglePaymentUrl(
                                            "20",
                                            this.props.subAccountId,
                                            getQueryParameters()["hierarchyid"],
                                            this.props.subAccountHierarchyId
                                        )}
                                    >
                                        Single Payment/Transfer
                                    </a>{" "}
                                    or{" "}
                                    <a
                                        href={StaticUrls.RegularPaymentUrl(
                                            "20",
                                            this.props.subAccountId,
                                            getQueryParameters()["hierarchyid"],
                                            this.props.subAccountHierarchyId,
                                            this.props.isAddRegularPayment == true ? "add" : "edit"
                                        )}
                                    >
                                        Regular Payments
                                    </a>{" "}
                                    process if you want to add more contributions to an existing SIPP.
                                </span>
                            }
                        />
                    )}

                <RadiosEditor
                    cssWrapper="radio-group rg-150 mb-23"
                    selected={Product.PensionType ?? PensionType.None}
                    label={incomePaymentDetailsLabels.clientPensionBenifits}
                    options={Product.IsDisqualifyingPensionCredits ? PensionTypesArrayNoITFLS : PensionTypesArray}
                    getText={(v) => {
                        return PensionTypesMap[v];
                    }}
                    onChange={(v) => {
                        this.onProductChange({ PensionType: v }, Product, productIndex);
                    }}
                    disabled={this.props.HasExistingSIPP == true || Product.IsDisqualifyingPensionCredits}
                    required="Please choose SIPP type"
                />
                {TrueFalseRadio(
                    incomePaymentDetailsLabels.needToProvideAnIncome,
                    "IsIncomePaymentDetailsSelected",
                    Product,
                    (key, value) => {
                        this.onProductChange({ [key]: value }, Product, productIndex);
                    },
                    true,
                    { 
                        disabled: Product.IsDisqualifyingPensionCredits,
                        cssWrapper: "radio-group rg-150 mb-16" 
                    }
                )}
                {TrueFalseRadio(
                    incomePaymentDetailsLabels.clientOptedOut,
                    "IsClientOptOutPensionSelected",
                    Product,
                    (key, value) => {
                        this.onProductChange({ [key]: value }, Product, productIndex);
                    },
                    true,
                    { cssWrapper: "radio-group rg-150 mb-16 has-tooltip" },
                    "The Aberdeen SIPP is suitable for members of employer sponsored schemes and employer payments can be accepted. However, it may not be a suitable option if your client's workplace arrangement offers preferential terms."
                )}
                <RetirementAge {...this.getProps("AnnuityAssumptions")} clientInfo={this.props.data.ClientDetails} />
                <p className="mb-24">This age/date is used for illustration purposes.</p>
                <PensionProtection label={"Edit pension protection"} {...this.getProps("PensionQuote")} isNewInstruction={this.props.data.AccountRoleInstructionId > 0 ? false : true} />
                { data?.SelectedProducts.some((item) => item.SubAccountType == SubAccountType.Npr) &&
                    <>
                        <DPCQuestion 
                            data={data}
                            onChange={(changes) => this.onDpcChange(changes)}
                            onRef={(ref) => this.appendChild(ref)}
                        />
                    </>
                }
                <hr className="mb-20" />
            </>
        );
    }
}
